import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { EventData } from '../../utils/excelParser';

interface EventUploadState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: EventUploadState = {
  loading: false,
  error: null,
  success: false,
};

const eventUploadSlice = createSlice({
  name: 'eventUpload',
  initialState,
  reducers: {
    uploadEventsRequest: (state, action: PayloadAction<EventData[]>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    uploadEventsSuccess: (state) => {
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    uploadEventsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetEventUploadState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  uploadEventsRequest,
  uploadEventsSuccess,
  uploadEventsFailure,
  resetEventUploadState,
} = eventUploadSlice.actions;

export default eventUploadSlice.reducer;
